import React, { FormEventHandler, useCallback, useEffect, useState } from 'react'
import { Empty } from '../chat-page/components'
import { Form as IForm, FormField as IFormField, getForm, submitForm } from '../backend'
import styled from 'styled-components'
import classNames from 'classnames'

const StyledForm = styled.form`
  flex: auto;
  min-height: 1px;
  padding: 20px;
  overflow-y: auto;
  
  h1 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: bold;
  }
  .formDesc {
    color: #8D8D8D;
    font-size: 14px;
    line-height: 1.5;
    p {
      margin: 0;
    }
  }
  section {
    margin: 12px 0 0 0;
  }
  button[type='submit'] {
    height: 40px;
    width: 100%;
    margin-top: 12px;
    border: none;
    border-radius: 10px;
    color: #FFFFFF;
    background-color: ${({ theme }) => theme.themeColor};
    background-image: ${({ theme }) => theme.backgroundImage};
  }
`
const FormFieldContainer = styled.div`
  label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: bold;
    &.required::after {
      content: '*';
      margin-left: 2px;
      color: #F0375B;
    }
  }
  & + & {
    margin-top: 12px;
  }
  input, textarea {
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 2px;
    background-color: #F6F8FA;
  }
  input[type='text'] {
    height: 40px;
  }
  textarea {
    
  }
`
const AUTOCOMPLETE_VALUES: { [key: string]: string } = {
  username: 'name',
  mobile_phone: 'tel-national',
  home_phone: 'tel-national',
  email_address: 'email',
  company: 'organization',
  title: 'organization_title',
  address: 'address-line1'
}
const getAutoCompleteValue = (field: IFormField) => {
  return AUTOCOMPLETE_VALUES[field.fieldName] ?? 'off'
}
export interface FormProps {
  formId: number | null
  onSuccess: (formData:FormData) => void
}
export const Form: React.VFC<FormProps> = ({ onSuccess, formId }) => {
  const [form, setForm] = useState<IForm>()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (formId !== null && !form) {
      getForm(formId).then(setForm)
    }
  }, [formId, form])
  const submit = useCallback<FormEventHandler<HTMLFormElement>>(async e => {
    e.preventDefault()
    if (form && e.currentTarget) {
      const formData = new FormData(e.currentTarget as HTMLFormElement)
      try {
        setLoading(true)
        await submitForm(form?.websiteFormId, formData)
        onSuccess(formData)
      } catch (e) {
        console.log(e)
        alert('提交失败')
      } finally {
        setLoading(false)
      }
    }
  }, [form, onSuccess, setLoading])
  return form
    ? (
      <StyledForm onSubmit={submit}>
        <div className="formDesc" dangerouslySetInnerHTML={{ __html: form.formDesc }} />
        {form.formFieldSectionDTOS.map(section => (
          <section key={section.formFieldSectionId}>
            {section.formFieldDTOS.map(field =>
              <FormField key={field.formFieldId} formField={field} />)}
          </section>
        ))}
        <button type="submit" disabled={loading}>{loading ? '提交中...' : '开启咨询'}</button>
      </StyledForm>
    )
    : <Empty />
}


interface FormFieldProps {
  formField: IFormField
}
const FormField: React.VFC<FormFieldProps> = ({ formField }) => {
  const id = `field-${formField.formFieldId}`
  const name = '' + formField.formFieldId
  return (
    <FormFieldContainer >
      <label htmlFor={id} className={classNames({ required: formField.required })}>{formField.showName}</label>
      {formField.displayType === 'input' && (
        <input
          id={id}
          name={name}
          type="text"
          required={formField.required}
          autoComplete={getAutoCompleteValue(formField)}
          pattern={formField.regexpValidation || undefined}
        />
      )}
      {formField.displayType === 'textarea' && (
        <textarea
          id={id}
          name={name}
          required={formField.required}
          autoComplete={getAutoCompleteValue(formField)}
          rows={3}
        />
      )}
    </FormFieldContainer>
  )
}
